import { render } from "./Confirm.vue?vue&type=template&id=f2b9adee"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
script.render = render

export default script